import React from 'react'
import { useLocation } from 'react-router-dom'
import '../../../../../common/RichTextEditor/LexicalEditor/themes/PlaygroundEditorTheme.css'
import '../../../../../common/RichTextEditor/LexicalEditor/ui/ContentEditable.css'
import '../../../../RichText/RichText.css'
import RenderHtml from '../../../../../common/AppSpecificConpnents/PartsTable/RenderHtml'
import {
  getRichTextCategoryDisplayValue,
  normalizeRichTextFieldForRenderHtml,
} from '../../utils/previewUtils'

const PreviewRichText = ({ version_content }) => {
  const { pathname } = useLocation()
  const hideFieldLabels =
    pathname.includes('/audit-trail/preview/') ||
    pathname.includes('/audit-trail/preview-current-node/') ||
    pathname.includes('/audit-trail/preview-deleted-node/')

  const { short_description, rich_text_content } = version_content
  const richTextCategoryLabel = getRichTextCategoryDisplayValue(version_content)
  /** Preview: flush left like ViewChildNode. Labeled audit: one 10px gutter only (no extra inner horizontal pad). */
  const richtextBodyInset = hideFieldLabels ? 0 : 10

  // Use rich_text_label if available, otherwise construct it
  const richTextLabel = version_content.rich_text_label || version_content.pageTitle || 'Rich Text'
  
  return (
    <div>
      <div style={{ padding: '20px' }}>
        {/* Rich Text Header */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '20px',
            paddingBottom: '20px',
            borderBottom: '3px double #e0e0e0',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input type="checkbox" defaultChecked={true} readOnly disabled />
            <h2 style={{ margin: 0, fontSize: '23px' }}>{richTextLabel}</h2>
          </div>
        </div>

        <div className="audit-trail-richtext-fields">
          {/* Short Description — same field shell as edit form so Lexical tables render correctly */}
          {short_description ? (
            <div
              className="richtext-editor-container"
              style={{ paddingLeft: '10px', paddingBottom: 0, marginTop: 0 }}
            >
              {!hideFieldLabels ? (
              <label className="richtext-editor-label">Short Description</label>
              ) : null}
              <div className="richtext-editor-wrapper" style={{ overflowX: 'auto' }}>
                <div className="rich-text-content-display" style={{ padding: '12px 16px' }}>
                  <RenderHtml
                    content={normalizeRichTextFieldForRenderHtml(short_description)}
                  />
                </div>
              </div>
            </div>
          ) : null}

          {/* Category: plain line on preview routes — same as ViewChildNode → RichTextNode */}
          {richTextCategoryLabel ? (
            hideFieldLabels ? (
              <div style={{ marginTop: '5px' }}>{richTextCategoryLabel}</div>
            ) : (
              <div style={{ marginLeft: '10px', marginTop: '12px', fontSize: '14px' }}>
                <span style={{ fontWeight: 600 }}>Rich Text Category </span>
                {richTextCategoryLabel}
              </div>
            )
          ) : null}

          {/* Rich Text Content */}
          {rich_text_content ? (
            <div
              className="richtext-editor-container"
              style={{
                paddingLeft: richtextBodyInset,
                paddingBottom: 0,
                marginTop:
                  hideFieldLabels
                    ? '5px'
                    : short_description
                      ? '16px'
                      : 0,
              }}
            >
              {!hideFieldLabels ? (
              <label className="richtext-editor-label">Rich text content</label>
              ) : null}
              <div className="richtext-editor-wrapper" style={{ overflowX: 'auto' }}>
                <div
                  className="rich-text-content-display"
                  style={{
                    fontSize: '14px',
                  
                    minWidth: 0,
                    clear: 'both',
                  }}
                >
                  <RenderHtml
                    content={normalizeRichTextFieldForRenderHtml(rich_text_content)}
                  />
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default PreviewRichText